// extracted by mini-css-extract-plugin
module.exports = {"section":"HomeHowToPay-module--section--BZnqC","text":"HomeHowToPay-module--text--2ao8Y"};